<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]">
    <v-nav-menu :navMenuItems="filteredNav" :title="getSystemSettings.systemName" :logo="getSystemSettings.logo"
      parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal :navbarType="navbarType" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" :navMenuItems="filteredNav" />
      </template>

      <template v-else>
        <the-navbar-vertical :navbarColor="navbarColor" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"></div>
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>

<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
// import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";

import { helperMixin } from "../../mixin/helperMixin";

import { mapGetters } from "vuex";
export default {
  mixins: [helperMixin],

  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
  },

  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: [
        {
          url: "/home",
          name: "Home",
          icon: "HomeIcon",
          slug: "main",
          i18n: "main",
          permissionName: "Home",
        },
        {
          url: "/dashboard/main",
          name: "Main Dashboard",
          icon: "PieChartIcon",
          slug: "main",
          i18n: "main",
          permissionName: "Dashboard",
        },
        {
          url: "/mtbe2023Dashboard",
          name: "Main Dashboard",
          icon: "PieChartIcon",
          slug: "main",
          i18n: "main",
          permissionName: "mtbe2023Dashboard",
        },
        {
          url: "/mtbe2024Dashboard",
          name: "Main Dashboard",
          icon: "PieChartIcon",
          slug: "main",
          i18n: "main",
          permissionName: "mtbe2024Dashboard",
        },
        {
          url: "/contractorDashboard",
          name: "Contractor Dashboard",
          icon: "UsersIcon",
          slug: "main",
          i18n: "main",
          permissionName: "contractorDashboard",
        },
        {
          url: "/eisDashboard",
          name: "EIS Dashboard",
          icon: "BoxIcon",
          slug: "main",
          i18n: "main",
          permissionName: "EIS Dashboard",
        },
        {
          url: "/subsystemDashboard",
          name: "Sub-System Dashboard",
          icon: "GridIcon",
          slug: "main",
          i18n: "main",
          permissionName: "Sub-system Dashboard",
        },
        {
          url: "/subsystemMtbe",
          name: "Sub-System Dashboard",
          icon: "GridIcon",
          slug: "main",
          i18n: "main",
          permissionName: "subsystemMtbe",
        },

        {
          url: "/areaDasboard",
          name: "Area Dashboard",
          icon: "GridIcon",
          slug: "main",
          i18n: "main",
          permissionName: "areaDasboard",
        },
        // {
        //   url: "/detailDashboard",
        //   name: "Detail Dashboard",
        //   icon: "BarChartIcon",
        //   slug: "packages",
        //   i18n: "packages",
        //   permissionName: "Dashboard",
        // },
        {
          url: "/form/projects/all",
          name: "Projects",
          icon: "ArchiveIcon",
          slug: "Projects",
          i18n: "Projects",
          permissionName: "Settings",
        },
        // {
        //   url: "/view/projectypes",
        //   name: "Project Types",
        //   icon: "LayersIcon",
        //   slug: "Projecttype",
        //   i18n: "Projecttype",
        //   permissionName: "Settings",
        // },
        // {
        //   url: "/view/rawjoinlists",
        //   name: "Joint List",
        //   icon: "SlidersIcon",
        //   slug: "settings",
        //   i18n: "Settings",
        //   permissionName: "System Settings",
        // },
        {
          url: "/joints",
          name: "Joint List",
          icon: "SlidersIcon",
          slug: "settings",
          i18n: "Settings",
          permissionName: "Joint List",
        },
        {
          url: "/JointListMtbe",
          name: "Joint List",
          icon: "SlidersIcon",
          slug: "settings",
          i18n: "Settings",
          permissionName: "JointListMtbe",
        },
        // Grid  ArchiveIcon GridIcon FilterIcon

        {
          header: "Settings",
          icon: "PieChartIcon",
          i18n: "ChartsAndMaps",
          permissionName: "Settings",
          items: [
            {
              url: "/settings",
              name: "System Settings",
              icon: "SettingsIcon",
              slug: "settings",
              i18n: "Settings",
              permissionName: "System Settings",
            },
            {
              url: "/view/jointypes",
              name: "Joint  Type",
              icon: "SettingsIcon",
              slug: "settings",
              i18n: "Settings",
              permissionName: "System Settings",
            },

            {
              url: null,
              name: "System Users",
              icon: "UsersIcon",
              tagColor: "success",
              i18n: "Charts",
              permissionName: "System Users",
              submenu: [
                {
                  url: "/view/users",
                  name: "System Users",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "System Users",
                },

                // {
                //   url: "/form/roles/role",
                //   name: "User Roles",
                //   slug: "usergroups",
                //   i18n: "userGroups",
                //   permissionName: "System Users",
                // },

                // {
                //   url: "/view/pages",
                //   name: "Pages",
                //   slug: "pages",
                //   i18n: "pages",
                //   permissionName: "System Users",
                // },
              ],
            },

            {
              url: null,
              name: "Master Tables",
              icon: "GridIcon",
              tagColor: "success",
              i18n: "Charts",
              permissionName: "hidden",
              submenu: [
                {
                  url: "/view/workcategories",
                  name: "Work Categories",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/equipementcategorytypes",
                  name: "Equipment Category Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/defectnos",
                  name: "Defect No.",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/jointCategories",
                  name: "Joint Category",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/equipmenttypes",
                  name: "Equipment Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/contractors",
                  name: "Contractors",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/tanos",
                  name: "Tano",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/lineclasses",
                  name: "Line Classes",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/areas",
                  name: "Areas",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/blindtypes",
                  name: "Blind Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/units",
                  name: "Units",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/criticals",
                  name: "Criticals",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/isolationmethods",
                  name: "Isolation Methods",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/boltingmethods",
                  name: "Bolting Methods",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/blindstandards",
                  name: "Blind Standards",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/lubricanttypes",
                  name: "Lubricant Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/flangetypes",
                  name: "Flange Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/gaskettypes",
                  name: "Gasket Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
                {
                  url: "/view/gaskettypes",
                  name: "Gasket Types",
                  slug: " ",
                  i18n: "ApexCharts",
                  permissionName: "Master Tables",
                },
              ],
            },
          ],
        },
      ],

      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
    };
  },

  computed: {
    ...mapGetters({
      getPermissions: "auth/getPermissions",
      getSystemSettings: "auth/getSystemSettings",
      getProjectSelected: "auth/getProjectSelected",
    }),
    filteredNav() {
      var menuItemCopy = this.navMenuItems;
      var projName = this.getProjectSelected.projectName;
      console.log("selected:", this.getProjectSelected)
      if (this.getPermissions != null) {
        var myPermission = this.getPermissions;
        console.log("permission:", myPermission);
        var mainFilter = menuItemCopy.filter((f) =>
          myPermission.includes(f.permissionName)
        );

        if (projName == "" || projName == undefined) {
          var home = ['Home'];
          mainFilter = menuItemCopy.filter((f) =>
            home.includes(f.name)
          );
        }

        //filter sub menus
        mainFilter.forEach((element) => {
          if (this.isset(element, "submenu")) {
            element.submenu = element.submenu.filter((f) =>
              myPermission.includes(f.permissionName)
            );
          }

          if (this.isset(element, "items")) {
            element.items = element.items.filter((f) =>
              myPermission.includes(f.permissionName)
            );

            element.items.forEach((el) => {
              if (this.isset(el, "submenu")) {
                el.submenu = el.submenu.filter((f) =>
                  myPermission.includes(f.permissionName)
                );
              }
            });
          }
        });

        console.log("mainFilter:", mainFilter);
        var finalMenu = ["Home", "Joint List", "Dashboard", "EIS Dashboard", "Sub-system Dashboard", "Projects", "Project Types", "Joint List", "Settings", "System Users"];
        if (this.getProjectSelected.projectType == "2") { // means it's the zero fire zero leak project type
          finalMenu = ["Home", "Joint List", "Projects", "Project Types", "Joint List", "Settings", "System Users"];
        }
        else if (this.getProjectSelected.projectType == "3") {
          finalMenu = ["Home", "Joint List", "Dashboard", "Projects", "Project Types", "Joint List", "Settings", "System Users"];
        }
        else if (this.getProjectSelected.projectType == "4") {
          finalMenu = ["Home", "Joint List", "Dashboard", "areaDasboard", "Projects", "Project Types", "Joint List", "Settings", "System Users"];
        }

        else if (this.getProjectSelected.projectType == "5") {
          finalMenu = ["Home", "JointListMtbe", "mtbe2023Dashboard", "contractorDashboard", "subsystemMtbe", "Projects", "Project Types", "Settings", "System Users"];
        }

        else if (this.getProjectSelected.projectType == "6") {
          finalMenu = ["Home", "JointListMtbe", "mtbe2024Dashboard", "contractorDashboard", "subsystemMtbe", "Projects", "Project Types", "Settings", "System Users"];
        }

        var menuBasedOnProjecttype = mainFilter.filter((f) =>
          finalMenu.includes(f.permissionName)
        );
        console.log("menuBasedOnProjecttype:", menuBasedOnProjecttype);

        return menuBasedOnProjecttype;
      } else {
        this.$router.push("/pages/login").catch(() => { });
      }
    },
    bodyOverlay() {
      return this.$store.state.main.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default") return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.main.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.main.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.main.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.main.windowWidth;
    },
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.main.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },

  created() {
    //this.$store.dispatch("auth/getPermission");
    console.log("settingsssssss:", this.getSystemSettings);
    const color =
      this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.main.mainLayoutType);
  },

  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("main/updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
  }
};
</script>

